import React from 'react';
import { Row, Col } from '@zendeskgarden/react-grid';
import { XL, LG, MD } from '@zendeskgarden/react-typography';
import { ItemCol, ItemRow } from './RfShieldingSolutions.styles.js';


const RfShieldingSolutions = (props) => {
  return (
    <div style={{margin: '0 auto', maxWidth: '1200px'}}>
      <Row>
        <Col size="12" style={{marginBottom: '40px'}}>
          <div>
            <XL bold  style={{margin: '0 auto', maxWidth: '700px'}} center paddingTopLg navy tag="h2">Our Solutions for MRI RF Shielding</XL>
            <LG center style={{margin: '0 auto', maxWidth: '700px'}} paddingTopMd paddingBottomLg navy light tag="h3">To deliver a reliable product, we offee two common and durable methods of RF shielding: Soldered-Seamed Copper and Gavanized Steel Panel Shielding.</LG>
          </div>
        </Col>
      </Row>
      
      <ItemRow>
        <ItemCol size="12" md={6}>
          <div>
            <MD uppercase paddingTopMd semibold blue tag="h3">Soldered-Seamed Copper RF Shielding</MD>
            <MD paddingBottomMd paddingTopMd slate light tag="h3">
              Soldered seamed copper is the best choice when quality and long term reliability are important. Our materials and construction techniques make use of the wisest choices in every category. The copper material has been carefully selected and tested to provide maximum durability and flexibility to meet challenging geometries.
            </MD>
          </div>
        </ItemCol>


        <ItemCol size="12" md={6}>
          <div>
            <MD uppercase paddingTopMd semibold blue tag="h3">Galvanized Steel Panel RF Shielding</MD>
            <MD paddingBottomMd paddingTopMd slate light tag="h3">
              Galvanized steel panel shielding systems are modular in nature and typically lower cost than soldered seamed copper.  This type of shield can be a self supporting structure independent of the parent building and requires no exterior framing or substrate to attach to.  
            </MD>
          </div>
        </ItemCol>

       

      </ItemRow>
    </div>
  )
}


export default RfShieldingSolutions;
